import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';

import { ButtonModule } from 'primeng/button';
import { CalendarModule } from 'primeng/calendar';
import { CheckboxModule } from 'primeng/checkbox';
import { DialogModule } from 'primeng/dialog';
import { DropdownModule } from 'primeng/dropdown';
import { DynamicDialogModule } from 'primeng/dynamicdialog';
import { InputSwitchModule } from 'primeng/inputswitch';
import { InputTextModule } from 'primeng/inputtext';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { MultiSelectModule } from 'primeng/multiselect';
import { RippleModule } from 'primeng/ripple';
import { SelectButtonModule } from 'primeng/selectbutton';
import { TableModule } from 'primeng/table';
import { TabViewModule } from 'primeng/tabview';
import { TooltipModule } from 'primeng/tooltip';

import { MarkdownEditorModule } from '../../components/markdown-editor/markdown-editor.module';
import { TargetInputModule } from '../../components/target-input/target-input.module';

import { ContentRegionListComponent } from './content-region-list.component';
import { ContentRegionComponent } from './content-region.component';
import { SuburbsModule } from './suburbs/suburbs.module';
import { ContentCharityListComponent } from './content-charity-list.component';
import { ContentCharityComponent } from './content-charity.component';
import { ContentBlogListComponent } from './content-blog-list.component';
import { ContentBlogComponent } from './content-blog.component';
import { ContentPageListComponent } from './content-page-list.component';
import { ContentPageComponent } from './content-page.component';
import { ContentMenuListComponent } from './content-menu-list.component';
import { ContentMenuComponent } from './content-menu.component';
import { ContentTemplateCopyListComponent } from './content-template-copy-list.component';
import { ContentTemplateCopyComponent } from './content-template-copy.component';
import { ContentSectionsEditorModule } from './content-sections-editor.module';
import { BlockPreviewModule } from './block-preview/block-preview.module';
import { ContentSiteServiceListComponent } from './content-site-service-list.component';
import { ContentSiteServiceComponent } from './content-site-service.component';

/**
 * Content module UI — regions + suburbs + charity partners + blog articles
 * list/editor modals for the Content Manager role. Suburbs is one workspace
 * (map, list, side panel; #256) rather than a list. Persistence is via
 * accountService.patchContent (the gated /account/content route). picaluna-v3
 * mirrors these into its location tree + /charity-partners + /blog pages.
 */
@NgModule({
  declarations: [
    ContentRegionListComponent,
    ContentRegionComponent,
    ContentCharityListComponent,
    ContentCharityComponent,
    ContentBlogListComponent,
    ContentBlogComponent,
    ContentPageListComponent,
    ContentPageComponent,
    ContentMenuListComponent,
    ContentMenuComponent,
    ContentTemplateCopyListComponent,
    ContentTemplateCopyComponent,
    ContentSiteServiceListComponent,
    ContentSiteServiceComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    TableModule,
    TabViewModule,
    TooltipModule,
    ButtonModule,
    RippleModule,
    InputTextModule,
    InputTextareaModule,
    InputSwitchModule,
    DropdownModule,
    CalendarModule,
    MultiSelectModule,
    DynamicDialogModule,
    DialogModule,
    CheckboxModule,
    SelectButtonModule,
    MarkdownEditorModule,
    TargetInputModule,
    ContentSectionsEditorModule,
    BlockPreviewModule,
    SuburbsModule,
  ],
  exports: [
    ContentRegionListComponent,
    ContentRegionComponent,
    SuburbsModule,
    ContentCharityListComponent,
    ContentCharityComponent,
    ContentBlogListComponent,
    ContentBlogComponent,
    ContentPageListComponent,
    ContentPageComponent,
    ContentMenuListComponent,
    ContentMenuComponent,
    ContentTemplateCopyListComponent,
    ContentTemplateCopyComponent,
    ContentSiteServiceListComponent,
    ContentSiteServiceComponent,
    ContentSectionsEditorModule,
  ],
})
export class ContentModule {}
